import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'


@Component({
    selector: 'app-video-dialog',
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule]
})
export class VideoDialogComponent {
  public videoUrl?: SafeResourceUrl

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private readonly sanitizer: DomSanitizer,
    private readonly matDialogRef: MatDialogRef<VideoDialogComponent>,
  ) {
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.replace('watch?v=', 'embed/'))
  }

  public close(): void {
    this.matDialogRef.close()
  }
}
